













export default
	props: tastingNotes: Array

	# Putting title and body in data in case we want to swap for CMS dictated
	data: ->
		sectionTitle: "Tasting Notes"
		sectionBody: "Unique natural flavor profiles for you to enjoy."



